<template>
  <div class="bind-box">
    <el-dialog :visible="$store.state.showBindBox==0?false:true" width="30%" :before-close="_handleClose">
      <el-dialog width="30%" :visible.sync="innerVisible" append-to-body>
        <span slot="title">
          {{$store.state.showBindBox==1?'绑定已有的真实账户':$store.state.showBindBox==2?'绑定已有的模拟账户':''}}
        </span>
        <el-form :model="accountData" :rules="accountRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="帐号" prop="account">
            <el-input v-model="accountData.account" placeholder="请输入帐号"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="accountData.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_submitForm('ruleForm')" v-loading="bindLoading">立即绑定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog width="40%" :visible.sync="innerVisible2" append-to-body>
        <span slot="title">
          {{$store.state.showBindBox==1?'激活真实账户':$store.state.showBindBox==2?'激活模拟账户':''}}
        </span>
        <el-row :gutter="40">
          <el-col :span="12">
            <div class="real_account is-active">
              <span class="icon_acc"><img src="@/assets/image/real_icon.png" /></span>
              <span class="icon_text">真实账户</span>
            </div>
            <p>
              一方实战场地，注资将不再受限制，赚取真金白银后也可以立即提现。如果您已经掌握基本规则，完善身份资料，激活真实账户试试身手吧！
            </p>
          </el-col>
          <el-col :span="12">
            <div class="real_account is-active">
              <span class="icon_acc"><img src="@/assets/image/demo_icon.png" /></span>
              <span class="icon_text">模拟账户</span>
            </div>
            <p>
              是一个虚拟的网上交易账号，账户中的资金为虚拟，商品、报价、图表、买卖等均与真实交易系统即时同步，是新手入门贵金属交易的最佳演练场。
            </p>
          </el-col>
        </el-row>
        <el-row class="margin-top-set" v-if="$store.state.showBindBox==1">
          <el-col :span="18" :offset="3">
            <el-form :model="accountData2" :rules="accountRules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
              <el-form-item label="真实姓名" prop="name">
                <el-input v-model="accountData2.name" placeholder="请输入真实姓名"></el-input>
              </el-form-item>
              <el-form-item label="证件号码" prop="credentialsNum">
                <el-row>
                  <el-col :span="7">
                    <el-select v-model="accountData2.issueCountry">
                      <el-option label="中国大陆" value="1"></el-option>
                      <el-option label="中国香港" value="2"></el-option>
                      <el-option label="中国澳门" value="3"></el-option>
                      <el-option label="中国台湾" value="4"></el-option>
                      <el-option label="其他国家及地区" value="5"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16" :offset="1">
                    <el-input v-model="accountData2.credentialsNum" placeholder="请输入证件号码"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="设置密码" prop="pwd">
                <el-input v-model="accountData2.pwd" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="推广编号" prop="promotionNumber">
                <el-input v-model="accountData2.promotionNumber" placeholder="请输入推广编号（非必填）"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_submitForm2('ruleForm2')" v-loading="bindLoading2">立即绑定</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row class="margin-top-set" v-if="$store.state.showBindBox==2">
          <el-col :span="18" :offset="3">
            <el-form :model="accountData3" :rules="accountRules3" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
              <el-form-item label="姓名">
                <el-input :value="$store.state.userInfo.jfUser.name" disabled placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item label="手机">
                <el-input :value="$store.state.userInfo.jfUser.mobile" disabled placeholder="手机"></el-input>
              </el-form-item>
              <!-- <el-form-item label="邮箱">
                <el-input :value="$store.state.userInfo.jfUser.email" disabled placeholder="邮箱"></el-input>
              </el-form-item> -->
              <el-form-item label="设置密码" prop="pwd">
                <el-input v-model="accountData3.pwd" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="_submitForm3('ruleForm3')" v-loading="bindLoading3">立即绑定</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-dialog>
      <el-row>
        <el-col :span="18" :offset="3">
          <el-button class="btn-width" type="primary" @click="_bindAccount">{{$store.state.showBindBox==1?'绑定已有的真实账户':$store.state.showBindBox==2?'绑定已有的模拟账户':''}}</el-button>
        </el-col>
        <el-col :span="18" :offset="3">
          <el-button class="btn-width" type="primary" plain @click="_activationAccount">{{$store.state.showBindBox==1?'无真实账户，马上去激活':$store.state.showBindBox==2?'无模拟账户，马上去激活':''}}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import { bindAccount } from '@/api'
  import { base64 } from '@/utils'
  export default {
    data() {
      let checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'));
        } else if (!(/(^([a-zA-Z]+)(\s*[a-zA-Z])+$)|(^[\u4e00-\u9fa5]{2,20}$)/.test(value))) {
          callback(new Error('姓名格式不正确!'));
        } else {
          callback();
        }
      };
      let checkCardNumber = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('证件号码不能为空'));
        } else if (this.accountData2.issueCountry == '1') {
          if (!(/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(value))) {
            callback(new Error('请正确输入证件号码!'));
          } else if (!this.isValida()) {
            callback(new Error('证件号码已被注册!'));
          } else {
            callback()
          }
        } else {
          callback();
        }
      };
      let checkPwd = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('密码不能为空'));
        } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/.test(value)) {
          callback(new Error('密码格式为6-12位字母加数字'));
        } else {
          callback();
        }
      };
      return {
        innerVisible: false,
        innerVisible2: false,
        accountData: {
          account: '',
          password: ''
        },
        accountRules: {
          account: [
            { required: true, message: '请输入帐号', trigger: 'blur' },
            { min: 6, max: 20, message: '帐号格式错误', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, max: 20, message: '密码最少6位', trigger: 'blur' }
          ]
        },
        accountData2: {
          name: '',
          credentialsNum: '',
          issueCountry: '1',
          // birthday: '',
          promotionNumber: '',
          pwd: '',
          fromType: 1
        },
        accountRules2: {
          name: [
            { validator: checkName, trigger: 'blur' }
          ],
          credentialsNum: [
            { validator: checkCardNumber, trigger: 'blur' }
          ],
          pwd: [
            { validator: checkPwd, trigger: 'blur' }
          ],
        },
        accountData3: {
          pwd: '',
          fromType: 1
        },
        accountRules3: {
          pwd: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
            { min: 6, message: '密码最少6位', trigger: 'blur' }
          ],
        },
        bindLoading: false,
        bindLoading2: false,
        bindLoading3: false
      }
    },
    methods: {
      isValida() {
        let params = {
          ident: this.accountData2.credentialsNum
        }
        let res = this.validateData(params)
        return res
      },
      //验证数据是否重复
      validateData(params) {
        let isVal = true
        bindAccount.realUserData(params).done(res => {
          if (!res.IsSuccess) {
            isVal = false
          }
        })
        return isVal
      },
      _handleClose() {
        this.$store.commit('setBindBoxStatue', 0)
      },
      // 绑定账户
      _bindAccount() {
        if (this.$store.state.showBindBox == 1 || this.$store.state.showBindBox == 2) {
          this.innerVisible = true
        }
      },
      // 激活账户
      _activationAccount() {
        if (this.$store.state.showBindBox == 1 || this.$store.state.showBindBox == 2) {
          this.innerVisible2 = true
        }
      },
      // 绑定
      _submitForm(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            this.bindLoading = true
            let params = {
              account: this.accountData.account,
              password: this.accountData.password,
              usertype:1
            }
            if (this.$store.state.showBindBox == 1) {
              bindAccount.realAccount(params).then(res => {
                this.bindLoading = false
                if (res.IsSuccess) {
                  this.innerVisible = false
                  this.$store.commit('setBindBoxStatue', 0)
                  this.$store.commit('setAccountType', 2)
                  this.$message.success(res.Data)
                  this.$emit('changeAcc', 1)
                }
              })
            } else if (this.$store.state.showBindBox == 2) {
              bindAccount.simulatorAccount(params).then(res => {
                this.bindLoading = false
                if (res.IsSuccess) {
                  this.innerVisible = false
                  this.$store.commit('setBindBoxStatue', 0)
                  this.$store.commit('setAccountType', 2)
                  this.$message.success(res.Data);
                  this.$emit('changeAcc', 0)
                }
              })
            }
          } else {
            this.bindLoading = false
            return false;
          }
        });
      },
      _submitForm2(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            this.bindLoading2 = true
            let params = {
              name: this.accountData2.name,
              credentialsType: 1,
              credentialsNum: this.accountData2.credentialsNum,
              promotionNumber: this.accountData2.promotionNumber,
              pwd: this.accountData2.pwd,
              fromType: 1
            }

            bindAccount.realAccountAc(params).then(res => {
              this.bindLoading2 = false
              if (res.IsSuccess) {
                this.innerVisible2 = false
                this.$store.commit('setBindBoxStatue', 0)
                this.$store.commit('setAccountType', 2)
                this.$alert('您的真实帐号为' + res.Data, '激活成功', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$emit('changeAcc', 1)
                  }
                });
              }
            })
          } else {
            this.bindLoading3 = false
            return false;
          }
        });
      },
      _submitForm3(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            this.bindLoading3 = true
            let params = {
              pwd: this.accountData3.pwd,
              fromType: 1
            }
            bindAccount.simulatorAccountAc(params).then(res => {
              this.bindLoading3 = false
              if (res.IsSuccess) {
                this.innerVisible2 = false
                this.$store.commit('setBindBoxStatue', 0)
                this.$store.commit('setAccountType', 2)
                this.$alert('您的模拟帐号为' + res.Data, '激活成功', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.$emit('changeAcc', 0)
                  }
                });
              }
            })
          } else {
            this.bindLoading3 = false
            return false;
          }
        });
      }
    }
  }
</script>

<style>
  .margin-top-set {
    margin-top: 40px
  }
</style>


// WEBPACK FOOTER //
// src/views/common/bindBox.vue